module.exports = __webpack_public_path__ + "resources/img/img_intel_oneapi_m.767f57e229c8dea6cd134aee01df61c0.png";